import { render, staticRenderFns } from "./centerCart.vue?vue&type=template&id=23398160&scoped=true&"
import script from "./centerCart.vue?vue&type=script&lang=js&"
export * from "./centerCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23398160",
  null
  
)

export default component.exports